"use client";
import React from "react";

const List = ({ title, items }) => {
  return (
    <div style={{ maxWidth: 986, margin: "0 auto" }} className="p-1">
      <div
        style={{ marginTop: 50, marginBottom: 40 }}
        className="flex justify-center mPadding"
      >
        <h3>{title}</h3>
      </div>

      <div className="cWrapper mPadding">
        <ul className="steps">
          {items.map((item, index) => {
            return (
              <li key={index}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="stepNum">{index + 1}</div>
                      </td>
                      <td>
                        <div
                          dangerouslySetInnerHTML={{ __html: item.text }}
                        ></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default List;
